import { useMutation } from "@tanstack/react-query";
import { validateBrevoCredentials } from "../../api/bBrevoApi";

export const useValidateBrevo = () => {
  return useMutation({
    mutationKey: ["validate-brevo"],
    mutationFn: (data) => validateBrevoCredentials(data),
    onError: (error) => {
      console.error("Brevo validation error details:", error.response || error);
    },
  });
};
